import React from 'react';
import {
  IconButton,
  View,
  IconCommentLine,
  Popover,
  CloseButton,
  FormFieldGroup,
  TextInput,
} from '@instructure/ui';
import { getStore } from '../../../stores/StoreContext';
import { useEffect, useState } from 'react';
const CommentButton = (props) => {
  const PlayerStore = getStore('playerStore');
  const [isShowingContent, setIsShowingContent] = useState(false);

  useEffect(() => {
    if (props.open) {
      setIsShowingContent(true);
    } else {
      setIsShowingContent(false);
    }
  }, [props.open]);

  const renderCloseButton = () => (
    <CloseButton
      placement="end"
      offset="small"
      onClick={() => {
        setIsShowingContent(false);
        PlayerStore.setPlaying(true);
        props.onHide();
      }}
      screenReaderLabel="Close"
    />
  );

  return (
    <Popover
      renderTrigger={
        <IconButton
          as="span"
          size="small"
          margin="none none none x-small"
          screenReaderLabel="Pause Playback"
        >
          <IconCommentLine size="x-small" />
        </IconButton>
      }
      isShowingContent={isShowingContent}
      onShowContent={() => {
        setIsShowingContent(true);
        PlayerStore.setPlaying(false);
        props.onOpen();
      }}
      onHideContent={() => {
        setIsShowingContent(false);
        PlayerStore.setPlaying(true);
        props.onHide();
      }}
      on="click"
      screenReaderLabel="Popover Dialog Example"
      shouldContainFocus
      shouldReturnFocus
      shouldCloseOnDocumentClick={false}
      offsetY="16px"
    >
      <View padding="medium" display="block" as="form">
        {renderCloseButton()}
        <FormFieldGroup description="Log In">
          <TextInput renderLabel="Username" />
          <TextInput renderLabel="Password" type="password" />
        </FormFieldGroup>
      </View>
    </Popover>
  );
};

export default CommentButton;
